import React from 'react';
import type { IconProps } from '../types';

export const Save = (props: IconProps) => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 20 20"
    version="1.1"
    fill="none"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Floppy body */}
      <path d="M4.25 3.25h8.25l3.25 3.25V15.75A1.25 1.25 0 0 1 14.5 17H5.5a1.25 1.25 0 0 1-1.25-1.25V4.5A1.25 1.25 0 0 1 5.5 3.25z" />
      {/* Label strip */}
      <path d="M7.25 3.25v4h5.5v-4" />
      {/* Disk slot */}
      <rect
        x="6.75"
        y="12"
        width="6.5"
        height="3.75"
        rx="0.5"
      />
    </g>
  </svg>
);

export default Save;
